import { memo as Memo, useMemo, useRef, Fragment } from 'react'
import { useRouter } from 'next/router'

//* Components
import Animate from 'components/common/Animate'
import Container from 'components/common/Container'
import Text from 'components/common/Text'
import Image from 'components/common/Image'
import Icon from 'components/common/Icon'
import { Pagination, Navigation, EffectFade } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

//* Style
import 'swiper/css'
import SolutionListingStyle from './style'

const SolutionListing = Memo(({ data }) => {
	//! Router
	const router = useRouter()

	//! Divide Size
	const divideSize = 200

	//! Refs
	const titlesRef = useRef()
	const firstDescRefs = useRef()
	const secondDescRefs = useRef()
	const iconItemsRef = useRef([])
	const blackLayerRefs = useRef()

	return (
		<SolutionListingStyle>
			<div className={`sol-item`}>
				<Container row full className={`itemTextWrap`}>
					<div className={`col-8 col-ts-12 col-m-12`}>
						<Animate
							startY={'80%'}
							durationOpacity={0.5}
							startPoint={'+=20% bottom'}
							params={{
								opacityVertical: [titlesRef],
							}}
							dependency={router.asPath}
						>
							<Text tag={`h2`} className={`h5 primaryColor1 font-montserratarm-medium uppercase`} text={data.title} ref={titlesRef} />
						</Animate>
					</div>
					<div className={`emptyWrap col-4`} />
				</Container>

				<Container row full className={`infoWrap`}>
					<div className={`emptyWrap col-4`} />
					<div className={`col-8 col-ts-12 col-m-12`}>
						<div className={`descWrap`}>
							<Animate
								stagger={0.1}
								startY={'50%'}
								durationOpacity={0.5}
								startPoint={'+=20% bottom'}
								params={{
									opacityVertical: [firstDescRefs, secondDescRefs],
								}}
								dependency={router.asPath}
							>
								<Text
									ref={firstDescRefs}
									tag={`p`}
									className={`p3 primaryColor1 font-montserratarm-regular descCol`}
									text={`${
										data.text.length <= divideSize
											? data.text
											: data.text
													.split(' ')
													.slice(0, Math.floor(data.text.split(' ').length / 2))
													.join(' ')
									}`}
								/>
								<Text
									ref={secondDescRefs}
									tag={`p`}
									className={`p3 primaryColor1 font-montserratarm-regular descCol`}
									text={data.text
										.split(' ')
										.slice(Math.floor(data.text.split(' ').length / 2), Math.floor(data.text.split(' ').length))
										.join(' ')}
								/>
							</Animate>
						</div>

						<Container row full className={`iconsWrap`}>
							{data.points.map((point, ind) => {
								return (
									<Animate
										stagger={0.1}
										key={ind}
										startY={'50%'}
										durationOpacity={0.5}
										startPoint={'+=20% bottom'}
										params={{
											opacityVertical: [iconItemsRef],
										}}
										dependency={router.asPath}
									>
										<div ref={(ref) => (iconItemsRef.current[ind] = ref)} className={`pointItemWrap col-3 col-ts-3 col-m-6`}>
											<Image
												objectFit={'cover'}
												src={point.icon ? point.icon.url : '/images/default_icon.svg'}
												alt={point.icon ? point.icon.alt : 'Default Icon'}
											/>
											<Text
												tag={`h3`}
												className={`p2 primaryColor1 font-montserratarm-regular maxWidthStyle`}
												text={point.title}
											/>
										</div>
									</Animate>
								)
							})}
						</Container>
					</div>
				</Container>

				<Animate startPoint={'+=20% bottom'} params={{ layerTopToBottom: [blackLayerRefs] }}>
					<div className={'sliderCont'}>
						<Swiper
							effect={'fade'}
							className={'gallerySlider'}
							pagination={{
								type: 'fraction',
							}}
							navigation={{
								prevEl: '.arrow-wrap-prev',
								nextEl: '.arrow-wrap-next',
							}}
							modules={[Pagination, Navigation, EffectFade]}
						>
							{data.gallery.map((image, key) => {
								return (
									<SwiperSlide key={key}>
										<Image objectFit={'cover'} className={'slider-image'} src={image?.url} alt={image?.alt} />
									</SwiperSlide>
								)
							})}

							{data.gallery.length > 1 && (
								<>
									<div className={'arrow-wrap-prev'}>
										<Icon name={'arrow'} className={'slider-gallery-prev'} />
									</div>
									<div className={'arrow-wrap-next'}>
										<Icon name={'arrow'} className={'slider-gallery-next'} />
									</div>
								</>
							)}
						</Swiper>
						<div className='black-layer' ref={blackLayerRefs} />
					</div>
				</Animate>
			</div>
		</SolutionListingStyle>
	)
})

export default SolutionListing
